/**
 * The one icon set (Tabler, outline), re-exported under concept names.
 * Pages import from here, never from the library, so a swap is one file.
 * Sizes: 18 in navigation and toolbars, 16 inline with text, 24 in empty
 * states and media placeholders.
 */
export {
  IconActivity as Activity,
  IconArrowBackUp as Undo,
  IconArrowForwardUp as Redo,
  IconArrowsSplit as Related,
  IconBold as Bold,
  IconBrowser as Site,
  IconCheck as Check,
  IconChevronRight as Chevron,
  IconCode as Code,
  IconCopy as Copy,
  IconDownload as Download,
  IconExternalLink as OpenOutside,
  IconFile as File,
  IconFileText as TextItem,
  IconFolder as Folder,
  IconFolderPlus as NewFolder,
  IconFolderSymlink as Move,
  IconHeadset as Meeting,
  IconH1 as Heading1,
  IconH2 as Heading2,
  IconHistory as Versions,
  IconInbox as Inbox,
  IconItalic as Italic,
  IconKey as Key,
  IconLink as Link,
  IconList as BulletList,
  IconListNumbers as NumberedList,
  IconMessage as Comment,
  IconLogout as SignOut,
  IconMicrophone as Mic,
  IconNotes as Note,
  IconPencil as Edit,
  IconPlayerPause as Pause,
  IconPlayerPlay as Play,
  IconPlayerStop as Stop,
  IconPlug as Agents,
  IconPlus as Plus,
  IconQuote as Quote,
  IconRefresh as Retry,
  IconRestore as Restore,
  IconSearch as Search,
  IconSeparatorHorizontal as Divider,
  IconSettings as Settings,
  IconSourceCode as CodeBlock,
  IconSparkles as AiDetails,
  IconStrikethrough as Strike,
  IconTrash as Trash,
  IconUnderline as Underline,
  IconUpload as Upload,
  IconUsers as Members,
  IconVolume as Listen,
  IconWand as Write,
  IconX as Close,
} from '@tabler/icons-react';

export const ICON = { nav: 18, inline: 16, empty: 24, stroke: 2 } as const;
